const consents = {
  sd: ['sd_third_party'],
  hb: ['hb_third_party']
}

export const getConsent = (brand) => consents[brand] || []
